import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: 15px;
`;

export const Close = styled.a`
	color: ${tokens.color_gray_dark};
	cursor: pointer;
	text-decoration: underline;

	padding-top: 25px;
`;

export const Title = styled.p`
	font-weight: 600;
	margin: auto;
	font-size: 16px;
	display: flex;
	place-items: center;
	text-align: center;
	color: ${tokens.color_gray_dark};

	padding-bottom: 30px;
`;

export const Subtitle = styled.p`
	color: ${tokens.color_primary};
	font-size: 18px;
	line-height: 24px;
	text-align: center;
`;

export const List = styled.ul`
	padding: 35px 0 30px 10px;
	width: 380px;

	display: flex;
	flex-direction: column;
	align-items: center;

	color: ${tokens.color_gray_dark};
	font-weight: 500;
	line-height: 24px;

	li {
		display: flex;
		align-items: center;

		span {
			padding-left: 25px;
		}
	}

	li:nth-child(n + 2) {
		margin-top: 15px;
	}
`;
